export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_PACKAGE = 'SET_PACKAGE';
export const DEL_PACKAGE = 'DEL_PACKAGE';